module.exports = __webpack_public_path__ + "static/media/quiz_background.1c62a986.png";